import React from "react";
import PropTypes from "prop-types";
import EnergyChartScrollArrow from "./EnergyChartScrollArrow";
import ForwardIcon from "../../components/ForwardIcon";
import BackIcon from "../../components/BackIcon";
import EnergyChartDatePicker from "./EnergyChartDatePicker";

const EnergyChartScrollArrows = props => {
  return (
    <div className="cb-c-energy-chart__arrows">
      <div className="cb-c-energy-chart__arrows__backward" key="backward-arrow">
        <EnergyChartScrollArrow
          className="fable:inline-block"
          icon={<BackIcon height={12} />}
          onClick={props.onBackwardClick}
          isEnabled={props.canGoBackward}
        />
      </div>
      <div
        className="cb-c-energy-chart__date-range fable:px-2"
        key="date-range"
      >
        <EnergyChartDatePicker
          from={props.from}
          to={props.to}
          onDateChange={props.onDateChange}
        />
      </div>
      <div className="cb-c-energy-chart__arrows__forward" key="forward-arrow">
        <EnergyChartScrollArrow
          className="fable:inline-block"
          onClick={props.onForwardClick}
          isEnabled={props.canGoForward}
        />
      </div>
    </div>
  );
};

EnergyChartScrollArrows.propTypes = {
  canGoForward: PropTypes.bool,
  canGoBackward: PropTypes.bool,
  onForwardClick: PropTypes.func,
  onBackwardClick: PropTypes.func,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired
};

EnergyChartScrollArrows.defaultProps = {
  canGoForward: true,
  canGoBackward: true
};

export default EnergyChartScrollArrows;
